import {
  ArrowsPointingOutIcon,
  CursorArrowRaysIcon,
  PaintBrushIcon,
  TrashIcon,
  MagnifyingGlassIcon,
  InboxArrowDownIcon,
} from "@heroicons/react/24/outline";
import { MapPinIcon } from "@heroicons/react/24/solid";

export const MODES = {
  move: {
    locale: "move",
    icon: <ArrowsPointingOutIcon className="w-4 -ml-1 transform rotate-45" />,
    editModeOnly: false,
  },
  select: {
    locale: "select",
    icon: <CursorArrowRaysIcon className="w-4 -ml-1" />,
    editModeOnly: true,
  },
  pin: {
    locale: "add_pin",
    icon: <MapPinIcon className="w-4 -ml-0.5" />,
    editModeOnly: true,
  },
  highlight: {
    locale: "highlight",
    icon: <PaintBrushIcon className="w-4 -ml-1" />,
    editModeOnly: true,
  },
  fitbg: {
    locale: "fit_bg",
    icon: <MagnifyingGlassIcon className="w-4 -ml-1" />,
    editModeOnly: false,
  },
  delete: {
    locale: "delete",
    icon: <TrashIcon className="w-4 -ml-1" />,
    editModeOnly: true,
    visibleOn: "select"
  },
  save: {
    locale: "save",
    icon: <InboxArrowDownIcon className="w-4 -ml-1" />,
    editModeOnly: true,
    styleType: "default",
    textCls: "text-sm",
  },
};

export const COLORS = {
  yellow: "255, 255, 0",
  blue: "0, 0, 255",
  red: "255, 0, 0",
};
